import styles from './ReferralPage.module.scss';
import { Loading } from 'src/components/Loading';
import { useNavigate, useParams } from 'react-router-dom';
import { AppRoutes } from 'src/types';
import { useEffect } from 'react';
import { useGetUser } from 'src/hooks';
import { REFERRAL_ID } from 'src/constants';

export const ReferralPage = () => {
  const { referralCode } = useParams();
  const { isOpenTier, isSubscribedTier, isUltraTier, isTeamsTier } =
    useGetUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpenTier && referralCode) {
      localStorage.setItem(REFERRAL_ID, referralCode);
      navigate(AppRoutes.SIGN_UP, { replace: true });
    } else if (!isOpenTier && !isSubscribedTier && referralCode) {
      console.log('[ReferralPage] not isOpenTier with referralCode');
      localStorage.setItem(REFERRAL_ID, referralCode);
      navigate(AppRoutes.HOME, { replace: true });
    } else {
      navigate(AppRoutes.HOME, { replace: true });
    }
  }, [
    referralCode,
    isOpenTier,
    isSubscribedTier,
    isUltraTier,
    isTeamsTier,
    navigate,
  ]);

  if (!referralCode) {
    navigate(AppRoutes.HOME, { replace: true });
  }

  return (
    <div className={styles.root}>
      <Loading />
    </div>
  );
};
